import MiniPortfolio from "../components/MiniPortfolio";

export default function Portfolio() {
  return (
    <div className="bg-black text-white">
      <MiniPortfolio />
    </div>
  );
}
